import React, { useCallback, FC } from 'react';
import { TableHead, TableRow, TableCell } from '@dxb-web-ui-framework/design-system';
import { ColumnDef } from '../../types';

export interface TableGridHeaderProps {
  columnDefs: ColumnDef[];
}

const TableGridHeader: FC<TableGridHeaderProps> = ({ columnDefs }) => {
  const renderTableHeader = useCallback(
    () =>
      columnDefs.map(column => {
        if (Boolean(column.isHidden)) {
          return null;
        }
        return (
          <TableCell scope='col' key={column.id} {...column.columnHeaderCellProps}>
            {column.columnHeaderRenderer ? column.columnHeaderRenderer(column.label) : column.label}
          </TableCell>
        );
      }),
    [columnDefs],
  );

  return (
    <TableHead>
      <TableRow>{renderTableHeader()}</TableRow>
    </TableHead>
  );
};

export { TableGridHeader };
